export default {"src":"/_next/static/media/bts.fa31fc7e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};